import React, { FC } from 'react';
import ConfirmModal from './ConfirmModal';
import FollowModal from './FollowModal';
import PremiumInterruptionModal from './PremiumInterruptionModal';
import ReportModal from './ReportModal';
import SignUpModal from './SignUpModal';

const Modals: FC = () => (
  <>
    <ConfirmModal />
    <PremiumInterruptionModal />
    <SignUpModal />
    <ReportModal />
    <FollowModal />
  </>
);

export default Modals;
